//      
                                                                          

export default (
  droppables                       ,
  updated                    ,
)                        => ({
  ...droppables,
  [updated.descriptor.id]: updated,
});



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/patch-droppable-map.js